// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

export interface IDetachable {
    detach(): Promise<void>;
}
